import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { SalesProfilePlan } from 'app/api/services/sales-profile.service';

@Component({
  selector: 'app-sales-profile-summary-card',
  templateUrl: './sales-profile-summary-card.component.html',
  styleUrls: ['./sales-profile-summary-card.component.scss'],
  standalone: false,
})
export class SalesProfileSummaryCardComponent {
  /** AI-generated plan; null while loading or when generation failed. */
  @Input() plan: SalesProfilePlan | null = null;
  @Input() loading = false;
  /** Structured fallback shown when the plan couldn't be generated. */
  @Input() score: { trackLabel: string; focusAreas: string[] } | null = null;
  @Output() reset = new EventEmitter<void>();

  confirmOpen = false;

  readonly tileClass =
    'group flex items-center gap-3.5 w-full text-left px-4 py-3.5 rounded-xl border !border-slate-200/80 bg-white hover:!border-[var(--primary-color)] hover:bg-[color-mix(in_srgb,var(--primary-color)_4%,white)] hover:shadow-[0_10px_24px_-14px_rgba(15,23,42,.35)] transition-all';

  readonly tileIconClass =
    'shrink-0 w-10 h-10 rounded-xl flex items-center justify-center bg-[color-mix(in_srgb,var(--primary-color)_10%,white)] text-[var(--primary-color)]';

  readonly tileEyebrowClass =
    'block text-[11px] font-semibold uppercase tracking-[0.1em] text-slate-400';

  readonly tileTitleClass =
    'block text-[15px] font-semibold text-slate-900 truncate';

  readonly tileChevronClass =
    'ml-auto shrink-0 text-slate-300 group-hover:text-[var(--primary-color)] transition-colors';

  // The tile opens the sprint/onboarding "main page" (the preview/overview with
  // the Start button), not the module viewer. Both kinds use /sprints/preview/:id
  // discriminated by the ?type query param.
  sprintLink(): string[] {
    return ['/sprints', 'preview', this.plan?.sprintId ?? ''];
  }

  get sprintTypeParam(): string {
    return this.plan?.sprintKind === 'Onboarding' ? 'Onboarding' : 'Sprint';
  }

  focusAreaLink(area: SalesProfilePlan['focusAreas'][number]): string[] {
    return area.focusAreaId
      ? ['/personalplan', area.focusAreaId]
      : ['/personalplan'];
  }

  onResetClick(): void {
    this.confirmOpen = true;
  }

  onConfirmCancel(): void {
    this.confirmOpen = false;
  }

  onConfirmReset(): void {
    this.confirmOpen = false;
    this.reset.emit();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.confirmOpen) {
      this.onConfirmCancel();
    }
  }
}
